import {
  Component,
  Input,
  ViewContainerRef,
  ViewChild,
  Injector,
  ComponentFactoryResolver,
  Compiler,
  OnInit,
  ComponentRef,
} from '@angular/core';
import { CustomPhoneComponent } from '../base-components/custom-phone/custom-phone.component';
import { BasicLabelComponent } from '../base-components/basic-label/basic-label.component';
import { BasicTextComponent } from '../base-components/basic-text/basic-text.component';
import { BasicTextInputComponent } from '../base-components/basic-text-input/basic-text-input.component';
import { CustomNameLongComponent } from '../base-components/custom-name-long/custom-name-long.component';
import { TextSSNComponent } from '../base-components/text-ssn/text-ssn.component';
import { MissingComponent } from '../base-components/missing/missing.component';
import { CheckboxBasicComponent } from '../base-components/basic-checkbox/basic-checkbox.component';
import { RadioGroupComponent } from '../base-components/radio-group/radio-group.component';
import { TextAutoCompleteComponent } from '../base-components/text-autocomplete/text-autocomplete.component';
import { TextAutoCompleteAddressComponent } from '../base-components/address-autocomplete/address-autocomplete.component';
import { IterateCollectionComponent } from '../base-components/iterate-collection/iterate-collection.component';
import { CustomAddressLongComponent } from '../base-components/custom-address/custom-address-long.component';
import { SelectBasicComponent } from '../base-components/select-basic/select-basic.component';
import { CustomHeightComponent } from '../base-components/custom-height/custom-height.component';
import { CustomAddressShortComponent } from '../base-components/custom-address-short/custom-address-short.component';
import { CustomWaiverComponent } from '../base-components/custom-waiver/custom-waiver.component';
import { TextAutoCompleteRXComponent } from '../base-components/text-autocomplete-rx/text-autocomplete-rx.component';
import { TextAutoCompleteRXNyComponent } from '../base-components/text-autocomplete-rx/text-autocomplete-rx-ny.component';
import { CustomDriversLicenseComponent } from '../base-components/custom-drivers-license/custom-drivers-license.component';
import { CustomDriversLicenseComponent2021 } from '../base-components/custom-drivers-license-2021/custom-drivers-license-2021.component';
import { SectionVerifyYourEmailComponent } from '../base-components/section-verify-your-email/section-verify-your-email.component';
import { CustomPercentComponent } from '../base-components/custom-percent/custom-percent.component';
import { SectionPleaseAcknowledgeComponent } from '../base-components/section-please-acknowledge/section-please-acknowledge.component';
import { TextDateShortComponent } from '../base-components/text-date-short/text-date-short.component';
import { TextDateLongComponent } from '../base-components/text-date-long/text-date-long.component';
import { CustomDiagnosisShortComponent } from '../base-components/custom-diagnosis-short/custom-diagnosis-short.component';
import { CustomSSNComponent } from '../base-components/custom-ssn/custom-ssn.component';
import { TextAreaComponent } from '../base-components/text-area/text-area.component';
import { OptionalInputComponent } from '../base-components/optional-input/optional-input.component';
import { ModalTriggerButtonComponent } from '../base-components/modal-trigger-button/modal-trigger-button.component';
import { SectionOwnerEmailComponent } from '../base-components/section-owner-email/section-owner-email.component';
import { TextAutoCompleteDropDownComponent } from '../base-components/text-autocomplete-dropdown/text-autocomplete-dropdown.component';
import { CustomFamilyMember } from '../base-components/custom-family-member/custom-family-member.component';
import { PlaceOfBirthComponent } from '../base-components/place-of-birth/place-of-birth.component';
import { CheckboxBasicLargeComponent } from '../base-components/basic-checkbox-large/basic-checkbox-large.component';
import { CoverageDetailsComponent } from '../base-components/coverage-details/coverage-details.component';
import { UnsupportedButtonComponent } from '../base-components/unsupported-button/unsupported-button.component';
import { TeleCMIdisabledComponent } from '../base-components/tele-cmi-disabled/tele-cmi-disabled.component';
import { AgentSubmittedApplicationTypeComponent } from '../base-components/application-type/agent-submitted-application-type.component';
import { TeleCMICaseDetailsComponent } from '../base-components/tele-cmi-case-details/tele-cmi-case-details.component';
import { ExamOrderingProcessComponent } from '../base-components/exam-ordering-process/exam-ordering-process.component';
import { ProductSwitchButtonComponent } from '../base-components/product-switch-button/product-switch-button.component';

export const entryComponents = [
  MissingComponent,
  BasicTextInputComponent,
  BasicLabelComponent,
  BasicTextComponent,
  RadioGroupComponent,
  TextAutoCompleteComponent,
  TextAutoCompleteDropDownComponent,
  TextAutoCompleteAddressComponent,
  SelectBasicComponent,
  CustomNameLongComponent,
  CheckboxBasicComponent,
  CheckboxBasicLargeComponent,
  TextSSNComponent,
  CustomPhoneComponent,
  CustomHeightComponent,
  CustomAddressShortComponent,
  CustomAddressLongComponent,
  IterateCollectionComponent,
  CustomDriversLicenseComponent,
  CustomDriversLicenseComponent2021,
  TextAutoCompleteRXComponent,
  TextAutoCompleteRXNyComponent,
  SectionPleaseAcknowledgeComponent,
  TextDateShortComponent,
  TextDateLongComponent,
  CustomPercentComponent,
  SectionVerifyYourEmailComponent,
  CustomDiagnosisShortComponent,
  CustomSSNComponent,
  TextAreaComponent,
  CustomWaiverComponent,
  OptionalInputComponent,
  ModalTriggerButtonComponent,
  SectionOwnerEmailComponent,
  CustomFamilyMember,
  PlaceOfBirthComponent,
  CoverageDetailsComponent,
  UnsupportedButtonComponent,
  TeleCMIdisabledComponent,
  AgentSubmittedApplicationTypeComponent,
  TeleCMICaseDetailsComponent,
  ExamOrderingProcessComponent,
  ProductSwitchButtonComponent,
];

@Component({
  moduleId: module.id,
  selector: 'dynamic-component',
  entryComponents: entryComponents,
  templateUrl: './dynamic.component.html',
})
export class DynamicComponent {
  currentComponent = null;
  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef, static: true })
  dynamicComponentContainer: ViewContainerRef;
  @Input() wrapperClass: string;

  destroy() {
    if (this.currentComponent) {
      this.currentComponent.destroy();
    }
  }

  @Input() set componentData(data) {
    if (!data) {
      return;
    }
    const question = data.question;
    const loopIndex = data.loopIndex;
    const customWidth = data.customWidth;

    const inputProviders = [
      { provide: 'questionItem', useValue: question },
      { provide: 'loopIndex', useValue: loopIndex },
      { provide: 'customWidth', useValue: customWidth },
    ];

    const injector = Injector.create(inputProviders);
    const factory = this.getComponentFactory(question.controlType, question.type);
    const component = factory.create(injector);

    if (this.dynamicComponentContainer) {
      this.dynamicComponentContainer.insert(component.hostView);
    }

    if (this.currentComponent) {
      this.currentComponent.destroy();
    }

    this.currentComponent = component;
  }

  private getComponentFactory(controlType: string, type: string) {
    switch (type) {
      case 'DiagnosisShort':
      case 'Diagnosis':
        return this.resolver.resolveComponentFactory(CustomDiagnosisShortComponent);
    }
    switch (controlType) {
      case 'label-basic':
        return this.resolver.resolveComponentFactory(BasicLabelComponent);
      case 'checkbox-basic':
        return this.resolver.resolveComponentFactory(CheckboxBasicComponent);
      case 'checkbox-basic-large':
        return this.resolver.resolveComponentFactory(CheckboxBasicLargeComponent);
      case 'radio-group':
      case 'radio-group-dynamic':
      case 'radio-group-vertical':
      case 'radio-group-with-text':
      case 'radio-group-with-text-date':
        return this.resolver.resolveComponentFactory(RadioGroupComponent);
      case 'application-type':
        return this.resolver.resolveComponentFactory(AgentSubmittedApplicationTypeComponent);
      case 'exam-ordering-process':
        return this.resolver.resolveComponentFactory(ExamOrderingProcessComponent);
      case 'select-basic':
        return this.resolver.resolveComponentFactory(SelectBasicComponent);
      case 'text-autocomplete':
        return this.resolver.resolveComponentFactory(TextAutoCompleteComponent);
      case 'text-autocomplete-dropdown':
        return this.resolver.resolveComponentFactory(TextAutoCompleteDropDownComponent);
      case 'text-autocomplete-rx':
        return this.resolver.resolveComponentFactory(TextAutoCompleteRXComponent);
      case 'text-autocomplete-rx-ny':
        return this.resolver.resolveComponentFactory(TextAutoCompleteRXNyComponent);
      case 'address-autocomplete':
        return this.resolver.resolveComponentFactory(TextAutoCompleteAddressComponent);
      case 'text-ssn':
        return this.resolver.resolveComponentFactory(TextSSNComponent);
      case 'custom-ssn':
        return this.resolver.resolveComponentFactory(CustomSSNComponent);
      case 'text-area':
        return this.resolver.resolveComponentFactory(TextAreaComponent);
      case 'text-basic':
      case 'text-no-label':
      case 'text-ein-no-label':
      case 'text-ssn-no-label':
        return this.resolver.resolveComponentFactory(BasicTextComponent);
      case 'text-date-long-no-label':
      case 'text-date-long':
        return this.resolver.resolveComponentFactory(TextDateLongComponent);
      case 'text-date-short':
        return this.resolver.resolveComponentFactory(TextDateShortComponent);
      case 'optional-input':
        return this.resolver.resolveComponentFactory(OptionalInputComponent);
      case 'custom-phone-number':
      case 'custom-phone-number-optional':
        return this.resolver.resolveComponentFactory(CustomPhoneComponent);
      case 'custom-name-long':
        return this.resolver.resolveComponentFactory(CustomNameLongComponent);
      case 'iterate-collection':
        return this.resolver.resolveComponentFactory(IterateCollectionComponent);
      case 'custom-address-long':
        return this.resolver.resolveComponentFactory(CustomAddressLongComponent);
      case 'custom-height':
        return this.resolver.resolveComponentFactory(CustomHeightComponent);
      case 'custom-address-short':
        return this.resolver.resolveComponentFactory(CustomAddressShortComponent);
      case 'custom-waiver':
        return this.resolver.resolveComponentFactory(CustomWaiverComponent);
      case 'custom-driver-license':
      case 'custom-driver-license-non-optional':
        return this.resolver.resolveComponentFactory(CustomDriversLicenseComponent);
      case 'custom-driver-license-2021':
        return this.resolver.resolveComponentFactory(CustomDriversLicenseComponent2021);
      case 'section-verify-your-email':
        return this.resolver.resolveComponentFactory(SectionVerifyYourEmailComponent);
      case 'text-percent':
        return this.resolver.resolveComponentFactory(CustomPercentComponent);
      case 'section-please-acknowledge':
        return this.resolver.resolveComponentFactory(SectionPleaseAcknowledgeComponent);
      case 'section-owner-email':
        return this.resolver.resolveComponentFactory(SectionOwnerEmailComponent);
      case 'custom-family-member':
        return this.resolver.resolveComponentFactory(CustomFamilyMember);
      case 'place-of-birth':
        return this.resolver.resolveComponentFactory(PlaceOfBirthComponent);
      case 'coverage-details':
        return this.resolver.resolveComponentFactory(CoverageDetailsComponent);
      case 'unsupported-button':
        return this.resolver.resolveComponentFactory(UnsupportedButtonComponent);
      case 'tele-cmi-disabled':
        return this.resolver.resolveComponentFactory(TeleCMIdisabledComponent);
      case 'tele-cmi-case-details':
        return this.resolver.resolveComponentFactory(TeleCMICaseDetailsComponent);
      case 'product-switch-button':
        return this.resolver.resolveComponentFactory(ProductSwitchButtonComponent);
      default:
        return this.resolver.resolveComponentFactory(MissingComponent);
    }
  }

  constructor(private resolver: ComponentFactoryResolver) {}
}
